import React from "react";
import { Container, Skeleton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { v4 as uuidv4 } from 'uuid';
import { columns } from "./clientsDetailsCreditsHeaders.js";
import { formatCurrency } from '../../../utils/Format.js';
import styles from "./clientsDetailsCreditsTableStyles.js";
import NoData from "../../SharedComponents/NoData/index.js";

const ClientsDetailsCreditsTable = ({ isLoading, creditsHistory = [], creditsSearch }) => {

  const filteredRows = creditsHistory.filter((entry) => {
    return Object.values(entry).some((value) =>
      value.toString().toLowerCase().includes(creditsSearch.toLowerCase())
    );
  });

  const rows = filteredRows?.map((entry, index) => ({
    id: uuidv4(),
    type_case: entry.type_case,
    amount: formatCurrency(entry.amount),
    description_case: entry.description_case,
    before_balance: formatCurrency(entry.before_balance),
    after_balance: formatCurrency(entry.after_balance),
    register_date: entry.register_date.toString().substring(0, 15),
  }));

  return (
    <Container sx={styles.mainContainer}>
      {isLoading ? (
        <Container sx={styles.skeletonMainContainer}>
          <Container sx={styles.skeletonSecondaryContainer}>
            <Skeleton variant="rounded" width={'5%'} height={40} />
            <Skeleton variant="rounded" width={'20%'} height={40} />
            <Skeleton variant="rounded" width={'30%'} height={40} />
            <Skeleton variant="rounded" width={'20%'} height={40} />
            <Skeleton variant="rounded" width={'20%'} height={40} />
            <Skeleton variant="rounded" width={'20%'} height={40} />
          </Container>
          <Container sx={styles.skeletonSecondaryContainer}>
            <Skeleton variant="rounded" width={'5%'} height={300} />
            <Skeleton variant="rounded" width={'20%'} height={300} />
            <Skeleton variant="rounded" width={'30%'} height={300} />
            <Skeleton variant="rounded" width={'20%'} height={300} />
            <Skeleton variant="rounded" width={'20%'} height={300} />
            <Skeleton variant="rounded" width={'20%'} height={300} />
          </Container>
        </Container>
      ) : (
        <DataGrid
          autoHeight
          disableColumnFilter
          rows={rows}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          getRowHeight={() => 'auto'} 
          sx={{
            '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '8px' },
            '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '15px' },
            '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '22px' },
          }}
          pageSizeOptions={[10, 20, 50, 100]}
          disableColumnMenu={true}
          disableSelectionOnClick={true}
          localeText={{
            noRowsLabel: <NoData title="No se encontraron registros" />,
          }}
        />
      )}
    </Container>
  );
};

export default ClientsDetailsCreditsTable;
